module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_6.e02eefb6.jpg";